export const JWT = "JWT";
export const RESOLUTION_STATE_VALUES = "RESOLUTION_STATE_VALUES";
